/**
 * Built-in map location categories (Tour Planner → add/edit custom location).
 * User-submitted categories approved in Admin merge at runtime from Firestore
 * (`locationCategorySuggestions` with status `approved`).
 */
export const BASE_LOCATION_CATEGORIES = [
  { id: 'venue', label: 'Venue', icon: '🎤' },
  { id: 'hotel', label: 'Hotel/Lodging', icon: '🏨' },
  { id: 'restaurant', label: 'Restaurant/Food', icon: '🍽️' },
  { id: 'gas', label: 'Gas Station', icon: '⛽' },
  { id: 'parking', label: 'Parking', icon: '🅿️' },
  { id: 'meeting', label: 'Meeting Point', icon: '📍' },
  { id: 'airport', label: 'Airport', icon: '✈️' },
  { id: 'store', label: 'Store/Shop', icon: '🛒' },
  { id: 'barbershop', label: 'Barbershops', icon: '✂️' },
  { id: 'rock_climbing_gym', label: 'Rock climbing gyms', icon: '🧗' },
  { id: 'fishing_destination', label: 'Fishing destinations', icon: '🎣' },
  { id: 'other', label: 'Other', icon: '📌' },
];
